import { render, staticRenderFns } from "./IconVirtualVisit.vue?vue&type=template&id=01b523b1&"
import script from "./IconVirtualVisit.vue?vue&type=script&lang=js&"
export * from "./IconVirtualVisit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports